import axios from 'axios'
import errorHandler from '@/plugins/errorHandler'

export default function useHttp() {
  return {
    $http: axios,
    errorHandler,
  }
}
